import PropTypes from 'prop-types'

import { Dropdown } from 'primereact/dropdown'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import { optionRow } from '@aytm/app/stats/page/question-views/components/controls/OptionLabel'
import HelpContent from '@aytm/app/stats/page/question-views/sft/components/HelpContent'

import { getViewModeList } from '@aytm/app/stats/page/question-views/sft/lib/utils'
import { DEFAULT_CHART_VIEW } from '@aytm/app/stats/page/question-views/sft/lib/constants'

import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const ControlsRapidAssociation = ({ features, viewMode, btnsType, onModelChange }) => {
  const options = getViewModeList({ features })

  const resolvedViewMode = viewMode || DEFAULT_CHART_VIEW

  const onChange = event => {
    onModelChange({
      viewMode: event.value
    })
  }

  return (
    <div className={`${style.component} ${NO_PRINT}`}>
      <div className="p-fluid p-col-3">
        <Dropdown
          className="p-dropdown-rounded"
          aria-label="View mode"
          ariaLabel="View mode"
          value={resolvedViewMode}
          options={options}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          itemTemplate={optionRow('ra-view-mode')}
          onChange={onChange}
        />
      </div>
      <Popup
        width="300px"
        trigger="click"
        direction="righttop"
        popupOffset={9}
        hideOtherPopupsOnShow
        content={() => <HelpContent viewMode={viewMode} btnsType={btnsType} />}
      >
        <i className="icon-aytmfd-help-v2" />
      </Popup>
    </div>
  )
}

ControlsRapidAssociation.propTypes = {
  features: PropTypes.object,
  viewMode: PropTypes.string,
  btnsType: PropTypes.string,
  onModelChange: PropTypes.func
}

ControlsRapidAssociation.displayName = 'ControlsRapidAssociation'

export default ControlsRapidAssociation
